import styled from 'styled-components'
import { motion } from 'framer-motion'

import { formatPriceByLocale } from 'utils/utils'

import SVGIcon from 'components/presenters/common/SVGIcon'
import SplitterBar from 'components/presenters/common/SplitterBar'

import ModalHeader from './ModalHeader'
import SelectBox from 'components/presenters/common/form/SelectBox'
import SelectOptionItem from './SelectOptionItem'
import PurchaseBtn from './PurchaseBtn'

export default function PurchaseModal({
  productTitle,
  type,
  onClose,
  whiteboxRef,
  isShowOption,
  productVariants,
  onSelectOption,
  onOptionDelete,
  selectOptions,
  totalPrice,
  lowestPrice,
  lowestChallengePrice,
  isValid,
  onQuantityIncrease,
  onQuantityDecrease,
  onClickPurchase,
}) {
  const fullScreen = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.5,
      },
    },
  }

  const whiteBox = {
    hidden: {
      opacity: 1,
      translateY: '100%',
    },
    show: {
      translateY: '0%',
    },
  }
  return (
    <FullScreen variants={fullScreen} initial="hidden" animate="show" exit="hidden">
      <WhiteBox ref={whiteboxRef} variants={whiteBox} initial="hidden" animate="show" exit="hidden">
        <HeaderBlock>
          <ModalHeader
            type={type}
            totalPrice={totalPrice}
            lowestPrice={lowestPrice}
            lowestChallengePrice={lowestChallengePrice}
          />
          <CloseBtnBlock onClick={onClose}>
            <SVGIcon name="close" />
          </CloseBtnBlock>
        </HeaderBlock>
        <SplitterBar margin={'0 0 calc(100vw * (25 / 375)) 0'} color={'#EFEFEF'} />
        {isShowOption && (
          <SelectBoxBlock>
            {productVariants?.map((variant) => (
              <SelectBox
                key={`product-variant-no-${variant.no}`}
                options={variant.options}
                controlShouldRenderValue={false}
                isSearchable={false}
                placeholder="옵션선택(필수)"
                onChange={onSelectOption}
              />
            ))}
          </SelectBoxBlock>
        )}
        {selectOptions.length > 0 && (
          <SelectOptionList>
            {selectOptions.map((option, index) => (
              <SelectOptionItem
                key={`select-option-no-${option.no}`}
                index={index}
                no={option.no}
                stock={option.stock}
                productTitle={productTitle}
                optionName={option.name}
                decreaseDisable={option.decreaseDisable}
                increaseDisable={option.increaseDisable}
                onOptionDelete={onOptionDelete}
                onQuantityDecrease={onQuantityDecrease}
                onQuantityIncrease={onQuantityIncrease}
                count={option.count}
                price={option.price}
              />
            ))}
          </SelectOptionList>
        )}
        <TotalPriceBlock>
          <TotalPriceLabel>총 금액</TotalPriceLabel>
          <TotalPrice>{`${formatPriceByLocale('ko', totalPrice)}원`}</TotalPrice>
        </TotalPriceBlock>
        {type === 'challenge' && (
          <PuchaseInfoBlock>
            <PurchaseQuantityInfo>{`* 수량은 1개까지 구입이 가능해요`}</PurchaseQuantityInfo>
          </PuchaseInfoBlock>
        )}

        <PurchaseBtn isValid={isValid} onClick={onClickPurchase} />
      </WhiteBox>
    </FullScreen>
  )
}

const FullScreen = styled(motion.div)`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100vh;
  opacity: 0;
  z-index: 300;
  transition: opacity 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`

const WhiteBox = styled(motion.div)`
  min-height: 1px;
  max-height: 100%;
  width: 100%;
  background-color: #fff;
  border-radius: calc(100vw * (20 / 375)) calc(100vw * (20 / 375)) 0 0;
  padding: calc(100vw * (22 / 375)) calc(100vw * (20 / 375)) calc(100vw * (14 / 375))
    calc(100vw * (20 / 375));
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`

const HeaderBlock = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: calc(100vw * (19 / 375));
`

const CloseBtnBlock = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #4e4e4e;
  }
`

const SelectBoxBlock = styled.div`
  width: 100%;
  margin-bottom: calc(100vw * (15 / 375));
`

const SelectOptionList = styled.ul`
  width: 100%;
  height: auto;
  max-height: calc(100vw * (278 / 375));
  margin-bottom: calc(100vw * (23 / 375));
  overflow-y: scroll;
`

const TotalPriceBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: calc(100vw * (19 / 375));
  margin-top: calc(100vw * (25 / 375));
`

const TotalPriceLabel = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (19 / 375));
  color: #121212;
`

const TotalPrice = styled.span`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (22 / 375));
  color: #121212;
`

const PuchaseInfoBlock = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: calc(100vw * (7 / 375));
`

const PurchaseQuantityInfo = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14 / 375));
  color: #7f7f7f;
`
